import { DataFetchingClient } from 'data-fetching-client';
export const filtersDataFetchingClient = new DataFetchingClient();